interface InputDateProps {
    name: string;
    label: string;
    value: string;
    subText?: string;
    required?: boolean;
    onChange: (name: string, value: string) => void;
    min?: string;
    max?: string;
}

const InputDate = ({ name, label, value, subText, onChange, required = false, min, max }: InputDateProps) => {
    return (
        <div className="input input--text">
            <label className="input__label">{label}</label>
            <input
                className="input__inp"
                type="date"
                value={value}
                onChange={(e) => onChange(name, e.target.value)}
                required={required === true}
                min={min}
                max={max}
            />
            {subText && <label className="input__label-sub" dangerouslySetInnerHTML={{ __html: subText }} />}
        </div>
    );
};

export default InputDate;
